import { defineComponent as $, useSlots as C, computed as z, openBlock as t, createElementBlock as l, unref as n, renderSlot as o, createCommentVNode as a, createElementVNode as _, Fragment as h, renderList as I, normalizeClass as S, createBlock as c, toDisplayString as p, mergeProps as B, toHandlers as L } from "vue";
import u from "@patsnap-biz/icon";
import { ListService as w, getSlotName as f } from "@patsnap-utils/biz";
const N = { class: "patsnap-biz-list" }, P = {
  key: 0,
  class: "patsnap-biz-list-prefix"
}, E = { class: "patsnap-ui-list" }, T = {
  key: 1,
  class: "patsnap-ui-list-divider__text"
}, V = /* @__PURE__ */ _("hr", null, null, -1), A = ["onClick"], D = ["href", "target"], F = {
  key: 2,
  class: "patsnap-ui-list-item__content"
}, H = {
  key: 1,
  class: "patsnap-biz-list-post"
}, j = /* @__PURE__ */ $({
  __name: "List",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  emits: ["itemClick"],
  setup(i, { emit: y }) {
    const v = i, d = C(), b = z(() => v.items.map(w.normalize)), g = (e) => {
      y("itemClick", e);
    }, m = (e) => {
      const r = "_blank";
      return e.href && e.target && e.target || r;
    };
    return (e, r) => (t(), l("div", N, [
      n(d).prefix ? (t(), l("div", P, [
        o(e.$slots, "prefix")
      ])) : a("", !0),
      _("ul", E, [
        (t(!0), l(h, null, I(b.value, (s, k) => (t(), l(h, null, [
          s && s.divider ? (t(), l("li", {
            key: `pt_list_${k}`,
            class: S({
              "patsnap-ui-list-divider": !0,
              "patsnap-ui-list-divider--with-icon": s.icon,
              "patsnap-ui-list-divider--with-label": s.label
            })
          }, [
            o(e.$slots, "divider", { item: s }, () => [
              s.icon ? (t(), c(n(u), {
                key: 0,
                icon: s.icon,
                class: "patsnap-ui-list-divider__icon"
              }, null, 8, ["icon"])) : a("", !0),
              s.label ? (t(), l("span", T, p(s.label), 1)) : a("", !0),
              V
            ])
          ], 2)) : (t(), l("li", B({
            key: `pt_list_else_${k}`,
            class: {
              active: s.active,
              "patsnap-ui-list-item": !0,
              ...s.classname ? { [s.classname]: !0 } : {}
            }
          }, L(s.$listeners || {}, !0), {
            onClick: (x) => g(s)
          }), [
            n(f)(s.label) ? o(e.$slots, n(f)(s.label), { key: 0 }) : o(e.$slots, "default", {
              key: 1,
              item: s
            }, () => [
              s.icon ? (t(), c(n(u), {
                key: 0,
                icon: s.icon,
                class: "patsnap-ui-list-item__pre-icon"
              }, null, 8, ["icon"])) : a("", !0),
              s.href ? (t(), l("a", {
                key: 1,
                href: s.href,
                target: m(s),
                class: "patsnap-ui-list-item__content"
              }, [
                _("span", null, p(s.label), 1)
              ], 8, D)) : (t(), l("span", F, p(s.label), 1)),
              s.postIcon ? (t(), c(n(u), {
                key: 3,
                icon: s.postIcon,
                class: "patsnap-ui-list-item__post-icon"
              }, null, 8, ["icon"])) : a("", !0)
            ])
          ], 16, A))
        ], 64))), 256))
      ]),
      n(d).post ? (t(), l("div", H, [
        o(e.$slots, "post")
      ])) : a("", !0)
    ]));
  }
}), q = (i) => i, M = q(j);
export {
  M as PtList,
  M as default
};
